// src/store/dashboard-store.ts
import { makeAutoObservable, runInAction} from 'mobx';
import { Appointment } from '../model/professional/booking-model';

export class DashboardStore {
    // État des données
    appointments: Appointment[] = [];
    isLoading: boolean = false

    constructor() {
        makeAutoObservable(this);
    }

    setIsLoading(){
            this.isLoading = true
    }

    // Actions pour modifier l'état
    setAppointments(appointments: Appointment[]) {
        runInAction(() => {
            this.appointments = appointments;
            this.setIsLoading()
        });
    }

    updateAppointment(id: string, newStatus: 'confirmed' | 'cancelled' | 'completed') {
        runInAction(() => {
            this.appointments = this.appointments.map(appointment =>
                appointment.id === id ? { ...appointment, status: newStatus } : appointment
            );
        });
    }

}

// Créer une instance singleton
const dashboardStore = new DashboardStore();
export default dashboardStore;